/**
 * Parse product code like "A1", "A2", "A10", "B1", "B2" into [letters, number]
 * for sorting: first by letter prefix (A, B, C...), then by number (1, 2, 10...).
 */
function parseCodeForSort(code: string | null | undefined): [string, number] {
  const s = (code ?? '').trim().toUpperCase()
  if (!s) return ['', 0]
  const match = s.match(/^([A-Z]*)(\d*)$/)
  if (!match) return [s, 0]
  const letters = match[1]
  const numStr = match[2]
  const num = numStr === '' ? 0 : parseInt(numStr, 10)
  return [letters, Number.isNaN(num) ? 0 : num]
}

function hasCode(code: string | null | undefined): boolean {
  return (code ?? '').trim().length > 0
}

/**
 * Compare two product codes for sort order (A1, A2, A10, B1, B2, ...).
 * Items without a code sort last.
 */
export function compareProductCode(
  codeA: string | null | undefined,
  codeB: string | null | undefined
): number {
  const aEmpty = !hasCode(codeA)
  const bEmpty = !hasCode(codeB)
  if (aEmpty && bEmpty) return 0
  if (aEmpty) return 1   // a after b
  if (bEmpty) return -1  // b after a
  const [lettersA, numA] = parseCodeForSort(codeA)
  const [lettersB, numB] = parseCodeForSort(codeB)
  if (lettersA !== lettersB) return lettersA.localeCompare(lettersB)
  return numA - numB
}
